import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {ErrorInfo} from '../../model/error-info';
import {isMyUpdatesErrorMessage, MyUpdatesErrorMessage} from '../../model/my-updates-error-message';
import {catchError} from 'rxjs/operators';
import {unauthenticated} from '@datev/ngx-dcal';


@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  private readonly headers: HttpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  constructor(private readonly httpClient: HttpClient) {
  }

  public get<T>(api: string, unauthenticatedAccess?: boolean): Observable<HttpResponse<T>> {

    // If the API is for MyUpdates-BE and requires unauthenticated access, we set the context to unauthenticated.
    const useUnauthenticated = unauthenticatedAccess ?? api.includes('api/amr/myupdates-be');

    if (useUnauthenticated) {
      return this.httpClient.get<T>(api, {headers: this.headers, observe: 'response', context: unauthenticated()})
        .pipe(catchError(this.handleError()));
    }
    return this.httpClient.get<T>(api, {headers: this.headers, observe: 'response'})
      .pipe(catchError(this.handleError()));
  }

  public getText(api: string): Observable<string> {
    const textHeaders = new HttpHeaders()
      .set('Accept', 'text/html, text/plain, text/css, */*');

    return this.httpClient.get(api, {headers: textHeaders, responseType: 'text', context: unauthenticated()})
      .pipe(catchError(this.handleError()));
  }

  public getBlob(api: string): Observable<Blob> {
    const blobHeaders = new HttpHeaders()
      .set('Accept', 'image/*, application/octet-stream');

    return this.httpClient.get(api, {headers: blobHeaders, responseType: 'blob', context: unauthenticated()})
      .pipe(catchError(this.handleError()));
  }

  private handleError<T>(): (err: HttpErrorResponse, caught: Observable<T>) => Observable<T> {
    return (err: HttpErrorResponse): Observable<T> => {
      let errorInfo: ErrorInfo;
      if (isMyUpdatesErrorMessage(err.error)) {
        const myUpdatesError: MyUpdatesErrorMessage = err.error;
        errorInfo = {
          errorCode: myUpdatesError.status,
          errorText: myUpdatesError.title,
          errorLink: myUpdatesError.type,
          errorLinkText: myUpdatesError.type
        };
      } else {
        errorInfo = {
          errorCode: err.status,
          errorText: err.message,
          errorLink: '',
          errorLinkText: ''
        };
      }
      return throwError(() => errorInfo);
    };
  }

}
